import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=6c0a1f14&scoped=true"
import script from "./RoleModal.vue?vue&type=script&lang=js"
export * from "./RoleModal.vue?vue&type=script&lang=js"
import style0 from "./RoleModal.vue?vue&type=style&index=0&id=6c0a1f14&prod&scoped=true&lang=scss"
import style1 from "./RoleModal.vue?vue&type=style&index=1&id=6c0a1f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a1f14",
  null
  
)

export default component.exports